module.exports = __webpack_public_path__ + "img/relatus_profile_white_2.5c171165.svg";